/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-expressions,@typescript-eslint/no-unused-vars */
import { parser } from '../../../app/services/pig-parser';
import { EVENTS } from '../../../app/constants/events';
import { DESIGNER_EVENTS } from '../../../app/constants/designer_events';

xplenty.directive('terminal', [
  '$rootScope',
  '$window',
  '$timeout',
  '$translate',
  '$http',
  'xplentyPigFunctions',

  function ($rootScope, $window, $timeout, $translate, $http, xplentyPigFunctions) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../views/directives/terminal.html'),

      replace: true,

      scope: {
        onTerminalCreationFn: '&?',
      },

      link(scope, element, attrs) {
        const $win = angular.element($window);

        scope.setSize = function () {
          let height = element.height();
          if (height > $window.innerHeight) {
            height = $window.innerHeight;
            element.height(height);
          }
          height -= 50;
          if (scope.term) scope.term.resize(element.width(), height);
        };

        const successHandler = function (res) {
          if (res.result === undefined) res.result = 'undefined';
          if (res.result === null) res.result = 'null';
          scope.term.echo(res.result);
        };

        const errorHandler = function (res) {
          if (angular.isDefined(res.responseJSON)) {
            scope.term.error(`ERROR: ${res.responseJSON.error}`);
          }
        };

        const sendRequest = function (command) {
          scope.term.pause();
          return $.ajax({
            method: 'POST',
            url: process.env.CONSOLE_URL,
            data: JSON.stringify(command),
            headers: {
              'Content-Type': 'application/json',
            },
          })
            .done(successHandler)
            .fail(errorHandler)
            .always(function () {
              scope.term.resume();
              scope.setSize();
            });
        };

        scope.$watch('isTerminalOpen', function (isTerminalOpen) {
          if (isTerminalOpen) {
            $timeout(function () {
              element.resizable({
                handles: 'n',
                containment: '.main-wrapper',
                minHeight: 200,
                resize(event, ui) {
                  scope.setSize();
                },
              });

              const $body = element.find('.terminal-body');

              if ($body.length) {
                $translate('terminal.greetings').then(function (greetings) {
                  scope.term = $body.terminal(
                    function (command, term) {
                      scope.term = term;

                      if (command !== '') {
                        let result;
                        try {
                          result = parser.parse(command);
                          sendRequest(result);
                        } catch (error) {
                          if (error instanceof Error) {
                            scope.term.error(error.toString());
                          }
                        }
                      }
                    },
                    {
                      exit: false,
                      greetings,
                      name: 'js_demo',
                      height: $body.height(),
                      width: $body.width(),
                      prompt: '> ',
                      tabcompletion: true,
                      caseSensitiveAutocomplete: false,
                      completion: _.map(xplentyPigFunctions.items, 'autocomplete'),
                    },
                  );

                  angular.isFunction(scope.onTerminalCreationFn) && scope.onTerminalCreationFn();
                });
              }
            }, 1000);
          }
        });

        $win.on('resize', scope.setSize);
        scope.isTerminalOpen = true;
      },

      controller: [
        '$scope',
        'NavigationHotkeys',

        function ($scope, NavigationHotkeys) {
          $scope.isTerminalOpen = true;

          $scope.close = function () {
            $scope.isTerminalOpen = false;

            NavigationHotkeys.unpause();

            $timeout(function () {
              $scope.$apply();
            });
          };

          $scope.toggleOpen = function (value) {
            $scope.isTerminalOpen = value;

            $timeout(function () {
              $scope.$apply();
            });

            if ($scope.isTerminalOpen) {
              NavigationHotkeys.pause();
            } else {
              NavigationHotkeys.unpause();
            }
          };

          $scope.$on(EVENTS.TERMINAL_TOGGLE, function () {
            $scope.toggleOpen();
          });

          $rootScope.$on(DESIGNER_EVENTS.TERMINAL, function (event, value) {
            $scope.toggleOpen(value);
          });

          $rootScope.$on(DESIGNER_EVENTS.TERMINAL_FOCUS, function () {
            $scope.term && $scope.term.focus();
          });
        },
      ],
    };
  },
]);
